export default {
  header: 'Informacje o piecu',
  text: 'Tekst',
  bgColor: 'Kolor tła',
};
